import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createTheme, MantineProvider } from '@mantine/core';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import 'normalize.css';
import '@feathr/components/dist/style/theme/index.css';
import '@feathr/components/dist/style/global/index.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const theme = createTheme({});

root.render(
  <MantineProvider theme={theme}>
    <App />
  </MantineProvider>,
);
